var map = {
	"./about/about.module": [
		"./src/app/about/about.module.ts",
		"about-about-module"
	],
	"./agree/agree.module": [
		"./src/app/agree/agree.module.ts",
		"agree-agree-module"
	],
	"./agree2/agree2.module": [
		"./src/app/agree2/agree2.module.ts",
		"agree2-agree2-module"
	],
	"./buy-credit/buy-credit.module": [
		"./src/app/buy-credit/buy-credit.module.ts",
		"common",
		"buy-credit-buy-credit-module"
	],
	"./chat-bot/chat-bot.module": [
		"./src/app/chat-bot/chat-bot.module.ts",
		"common",
		"chat-bot-chat-bot-module"
	],
	"./chat-room/chat-room.module": [
		"./src/app/chat-room/chat-room.module.ts",
		"common",
		"chat-room-chat-room-module"
	],
	"./claim-promo-code/claim-promo-code.module": [
		"./src/app/claim-promo-code/claim-promo-code.module.ts",
		"claim-promo-code-claim-promo-code-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"common",
		"login-login-module"
	],
	"./tab-chat-list/tab-chat-list.module": [
		"./src/app/tab-chat-list/tab-chat-list.module.ts",
		"common",
		"tab-chat-list-tab-chat-list-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;